const comments = [
  {
    name: '星野漫迷',
    avatar: '星',
    time: '2小时前',
    content: '哔咔动漫真是我每天必刷的网站！下拉阅读太方便了，追《咒术回战》最新话一口气看完完全不卡顿。最重要的是真的完全免费，太良心了！',
    likes: 328,
    tag: '忠实用户',
  },
  {
    name: '漫画控小林',
    avatar: '林',
    time: '5小时前',
    content: '从日漫到韩漫再到国漫，资源真的太全了。之前找了好久的《关于我转生变成史莱姆这档事》全卷在这里直接下拉看完，爽到飞起。',
    likes: 256,
    tag: '新用户',
  },
  {
    name: '深夜追更人',
    avatar: '夜',
    time: '1天前',
    content: '夜间模式真的很贴心，每天晚上睡前刷几话，眼睛不累。更新速度也超级快，热门连载基本第二天就能看到汉化版。',
    likes: 189,
    tag: '忠实用户',
  },
  {
    name: '国漫支持者',
    avatar: '国',
    time: '2天前',
    content: '国漫专区越来越丰富了！《一人之下》《狐妖小红娘》都有完整资源，画质也很清晰。强烈推荐给喜欢国漫的朋友们。',
    likes: 142,
    tag: '活跃用户',
  },
  {
    name: '甜宠爱好者',
    avatar: '甜',
    time: '3天前',
    content: '韩漫的甜宠恋爱系列简直是我的精神食粮！全部高清全彩，下拉阅读体验比翻页舒服太多了，已经安利给身边所有姐妹。',
    likes: 97,
    tag: '活跃用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            漫友热评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            来自真实漫友的使用反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading text-sm flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                      {c.tag}
                    </span>
                  </div>
                  <div className="text-xs text-foreground-400 mt-0.5">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.content}</p>
              <div className="flex items-center gap-1 mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
                <span className="ml-1">人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}